// genreBeat.js
const genres = [
  "Hip Hop",
  "Trap",
  "UK Drill",
  "Gangsta Rap",
  "Old School Hip Hop",
  "Cloud Rap",
  "Boom Bap",
  "Jazz Rap",
  "RnB",
  "Contemporary R&B",
  "Pop",
  "Synth Pop",
  "K-Pop",
  "Electropop",
  "Indie Pop",
  "House",
  "Deep House",
  "Tech House",
  "Progressive House",
  "EDM",
  "Dubstep",
  "Drum & Bass",
  "Trance",
  "Hardstyle",
  "Funk",
  "Disco Funk",
  "G-Funk",
  "Psychedelic Funk",
  "Drake Type",
  "Kendrick Type",
  "Travis Scott Type",
  "Eminem Type",
  "J Cole Type",
  "Nas Type",
  "Jay Z Type",
  "Carnatic",
  "Hindustani Classical",
  "Indian Folk",
  "Bollywood Contemporary",
  "Tamil Film Music",
  "Anirudh Type",
  "ARR Type",
  "HiphopTamizha Type",
  "Rap Tamil",
  "Telugu Film Music",
  "Kannada Film Music",
  "Malayalam Film Music",
  "Punjabi Bhangra",
  "Ghazal",
  "Qawwali",
  "Sufi Music",
  "Indian Pop (Indipop)",
  "Rajasthani Folk",
  "Gujarati Folk",
  "Psychedelic",
  "Psytrance",
  "Psychedelic Rock",
  "Ambient",
  "Chillout",
  "Lofi Hip Hop",
  "Vaporwave",
  "Future Bass",
  "Chillwave",
  "Synthwave",
  "Glitch Hop",
  "Moombahton",
  "Reggaeton",
  "Latin Trap",
  "Afrobeat",
  "Dancehall",
  "Reggae",
  "Ska",
  "Rock",
  "Classic Rock",
  "Alternative Rock",
  "Punk Rock",
  "Metal",
  "Heavy Metal",
  "Death Metal",
  "Black Metal",
  "Blues",
  "Delta Blues",
  "Chicago Blues",
  "Country",
  "Classic Country",
  "Modern Country",
  "Bluegrass",
  "Folk",
  "American Folk",
  "Celtic Folk",
  // Continue adding genres as needed
];

export const categorizedGenres = {
  "🎤 Hip Hop / Rap": [
    "Hip Hop",
    "Trap",
    "UK Drill",
    "Gangsta Rap",
    "Old School Hip Hop",
    "Cloud Rap",
    "Boom Bap",
    "Jazz Rap",
    "Lofi Hip Hop",
    "Drake Type",
    "Kendrick Type",
    "Travis Scott Type",
    "Eminem Type",
    "J Cole Type",
    "Nas Type",
    "Jay Z Type",
  ],
  "🎷Pop / RnB": [
    "RnB",
    "Contemporary R&B",
    "Pop",
    "Synth Pop",
    "K-Pop",
    "Electropop",
    "Indie Pop",
    "Indian Pop (Indipop)",
  ],
  " 🎧Electronic / EDM": [
    "House",
    "Deep House",
    "Tech House",
    "Progressive House",
    "EDM",
    "Dubstep",
    "Drum & Bass",
    "Trance",
    "Hardstyle",
    "Psytrance",
    "Future Bass",
    "Chillwave",
    "Synthwave",
    "Vaporwave",
    "Ambient",
    "Chillout",
  ],
  "🎸Rock / Metal": [
    "Rock",
    "Classic Rock",
    "Alternative Rock",
    "Punk Rock",
    "Metal",
    "Heavy Metal",
    "Death Metal",
    "Black Metal",
    "Psychedelic Rock",
  ],
  "🎷Funk / Reggae / World": [
    "Funk",
    "Disco Funk",
    "G-Funk",
    "Psychedelic Funk",
    "Reggae",
    "Dancehall",
    "Ska",
    "Afrobeat",
    "Latin Trap",
    "Reggaeton",
    "Moombahton",
  ],
  "🎻Indian ": [
    "Carnatic",
    "Hindustani Classical",
    "Indian Folk",
    "Bollywood Contemporary",
    "Tamil Film Music",
    "ARR Type",
    "Anirudh Type",
    "HiphopTamizha Type",
    "Rap Tamil",
    "Telugu Film Music",
    "Kannada Film Music",
    "Malayalam Film Music",
    "Punjabi Bhangra",
    "Ghazal",
    "Qawwali",
    "Sufi Music",
    "Rajasthani Folk",
    "Gujarati Folk",
  ],
  "🎼Country / Folk / Blues": [
    "Country",
    "Classic Country",
    "Modern Country",
    "Bluegrass",
    "Folk",
    "American Folk",
    "Celtic Folk",
    "Blues",
    "Delta Blues",
    "Chicago Blues",
  ],
};
export default genres;
